/* SEC_DRAWER_FIRST — Material-Karussell: komplett statisch (kein Wischen in
   irgendeine Richtung); Navigation ausschließlich per Pfeil-Button, Schritt für Schritt. */
(function () {
  'use strict';

  function initScroller(scroller) {
    if (scroller.dataset.dfInit) return;
    scroller.dataset.dfInit = '1';

    var section = scroller.closest('.smelu-df');
    var prev = section ? section.querySelector('[data-smelu-df-prev]') : null;
    var next = section ? section.querySelector('[data-smelu-df-next]') : null;
    var cards = Array.prototype.slice.call(scroller.querySelectorAll('.smelu-df__card'));
    var index = 0;

    function maxScroll() { return scroller.scrollWidth - scroller.clientWidth; }

    function updateArrows() {
      var atStart = scroller.scrollLeft <= 4;
      var atEnd = scroller.scrollLeft >= maxScroll() - 4;
      var noOverflow = maxScroll() < 8;
      if (prev) prev.classList.toggle('is-hidden', atStart || noOverflow);
      if (next) next.classList.toggle('is-hidden', atEnd || noOverflow);
    }

    function goTo(i) {
      if (!cards.length) return;
      index = Math.max(0, Math.min(i, cards.length - 1));
      var delta = cards[index].getBoundingClientRect().left - scroller.getBoundingClientRect().left;
      var target = Math.max(0, Math.min(scroller.scrollLeft + delta, maxScroll()));
      scroller.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(updateArrows, 400);
    }

    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });

    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('[data-smelu-df-scroller]').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
